module.exports = __webpack_public_path__ + "img/4F4F4F_9C9C9C_121212_7C7C7C-256px.4d35c082.png";